import React from "react";
import { useForm } from "react-hook-form";

export function Step02({ onSubmit, store }) {
  const { handleSubmit } = useForm({
    defaultValues: store,
  });

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <p className="font-medium text-lg text-center mt-4">
        <span className="font-bold">Step 1:</span> Complete the online
        questions.
      </p>
      <p className="font-medium text-lg text-center mt-4">
        <span className="font-bold">Step 2:</span> We will call you to discuss
        your case further.
      </p>
      <section>
        <p className="font-medium text-lg text-center m-4">
          <span className="font-bold">Step 3:</span> We will send you a free
          personalised Action Plan on what to do next and the legal process.
        </p>
      </section>
    </form>
  );
}
